export default import.meta.ROLLDOWN_FILE_URL_toMqwJ9AnYgx8OqHxnFaOw